import { Icon } from "@blueprintjs/core"
import { get, startCase } from "lodash-es"
import React from "react"
import ReactTable from "react-table"
import CustomTooltip from "components/Atoms/CustomTooltip"

export default function PreviewTable({ rows, loading }) {
  const data = get(rows, "0.data")

  const statusColumn = {
    Header: "Status",
    width: 70,
    accessor: "status",
    Cell({ value }) {
      return (
        <Icon
          icon={value === "success" ? "endorsed" : "delete"}
          intent={value === "success" ? "success" : "danger"}
        />
      )
    },
  }
  const COLUMNS =
    data &&
    Object.keys(data).map(c => {
      return {
        Header: startCase(c),
        accessor: c === "Sr.No." ? "sno" : `data.${c}`,
        width: startCase(c).length * 12,
        getProps: (_, info) => {
          let errors = []
          if (get(info, ["original", "error", c])) {
            errors = get(info, ["original", "error", c])
          } else {
            errors = get(info, ["original", "error", c.replace("_id", "")])
          }

          return {
            style: {
              background: errors && errors.length ? "#ffc4c4" : null,
            },
          }
        },
        Cell({ value, original }) {
          let errors = []
          if (get(original, ["error", c])) {
            errors = get(original, ["error", c])
          } else {
            errors = get(original, ["error", c.replace("_id", "")])
          }

          return (
            <>
              {errors && errors.length > 0 ? (
                <CustomTooltip
                  content={
                    <div className="px-3">
                      <ol>
                        {errors.map(e => {
                          return <li key={e}>{e}</li>
                        })}
                      </ol>
                    </div>
                  }
                >
                  <div>{value}</div>
                </CustomTooltip>
              ) : (
                value
              )}
            </>
          )
        },
      }
    })
  COLUMNS && COLUMNS.splice(1, 0, statusColumn as any)

  return (
    <ReactTable
      data={rows}
      loading={loading}
      loadingText="Fetching Demands..."
      className="-highlight vt-demand-table"
      resizable={true}
      style={{
        overflow: "visible",
        height: "75vh",
      }}
      getTrProps={(_, rowInfo) => {
        const status = get(rowInfo, "row.status")

        if (status && status === "error") {
          return {
            className: "bg-red-100",
          }
        } else if (status && status === "success") {
          return {
            className: "bg-green-100",
          }
        } else {
          return {}
        }
      }}
      columns={COLUMNS ? (COLUMNS as any) : []}
      defaultPageSize={100}
      showPaginationBottom={true}
    />
  )
}
